'use client';

import React from 'react';
import { TasticProps } from 'frontastic/tastics/types';
import { ContentstackRendererProps } from 'components/commercetools-ui/organisms/content/innovation-pages';
import ContentstackRenderer from 'components/commercetools-ui/organisms/content/innovation-pages';

const InnovationContainerTastic = ({ data }: TasticProps<ContentstackRendererProps>) => {
  return <ContentstackRenderer data={data?.data} />;
};

export default InnovationContainerTastic;
